// extracted by mini-css-extract-plugin
export default {"btnpwd":"_3dc538d6e9"};